import React from 'react';

export const CategoryRadio = (props) => {
    const { label, id, value, onChange, activeCategory, count } = props;
    let className = `map-category map-category--${id.toLowerCase()}`;

    if (activeCategory === id) className += ' -active';

    return (
        <div className={className} key={id}>
            <input
                id={'map-radio-' + id}
                name={'map-radio'}
                type="radio"
                value={value}
                defaultChecked={value === 0}
                // checked={id === activeCategory}
                // onChange={onChange}
            />
            <label htmlFor={'map-radio-' + id}>
                <div className="map-category__icon"></div>
                <div className="map-category__title">
                    <div className="h4">{label}</div>
                    <div className="map-category__counter">
                        Incidents: <strong>{count.toLocaleString()}</strong>
                    </div>
                </div>
            </label>
        </div>
    );
};
